import React, { useState, useEffect } from "react";

import Tabcontent from "../../components/consultation/tab_content";
import "../../assets/css/styles.css";
import "../../assets/libs/bootstrap/css/bootstrap.min.css";
import Spinner from "../../components/Spinner/spinner";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import api from "../../api";

const Consultation = () => {
  const [activeTab, setActiveTab] = useState("consultations");
  const [loading, setLoading] = useState(true);
  const [showSpinner, setShowSpinner] = useState(false);
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem(`${process.env.REACT_APP_LOCAL_TOKEN}`);
    const token_horoscope = localStorage.getItem(`${process.env.REACT_APP_LOCAL_TOKEN_HOROSCOPE}`);
    if (!token && !token_horoscope) {
      navigate("/signin", { replace: true });
    }
  }, []);
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tab = urlParams.get("tab");
    if (tab === "appointments") {
      setActiveTab("appointments");
    }
  }, []);

  return (
    <>
      {/* {loading ? (
        showSpinner && <Spinner />
      ) : ( */}
        <Tabcontent activeTab={activeTab} setActiveTab={setActiveTab} />
     {/*  )} */}
    </>
  );
};

export default Consultation;
